<template>
    <section class="bg-lifeboost-orange-100">
      <div class="relative px-4 py-6 mx-auto text-center sm:py-10 max-w-desktop lg:py-12 lg:px-14 sm:px-8 min-h-[360px]">
        <ClientOnly>
          <Swiper
            autoHeight
            :class="'relative overflow-hidden'"
            :autoplay="{ delay: 8000, disableOnInteraction: true, pauseOnMouseEnter: true }"
            :modules="[SwiperNavigation, SwiperAutoplay]"
            :slidesPerView="1"
            :spaceBetween="40"
            :loop="true"
            :rewind="true"
            :navigation="{
                          nextEl: '.swiper-button-next-latte',
                          prevEl: '.swiper-button-prev-latte'
                      }"
            :breakpoints="{
                          1024: { slidesPerView: 2 }
                      }"
          >
            <SwiperSlide v-for="(testimonial, index) in testimonials" :key="index">
              <div
                class="grid h-full grid-cols-12 overflow-hidden border border-black rounded-2xl bg-lifeboost-orange-dark"
              >
                <div
                  class="flex items-start order-2 col-span-12 py-4 pl-10 pr-2 sm:order-1 sm:col-span-7 sm:pr-6 lg:py-0 md:col-span-6 2xl:pl-10 2xl:pr-10 md-max:py-12"
                >
                  <blockquote
                    class="font-normal text-left text-white sm:pl-6 lg:text-18 md:text-xl 3xl:leading-30 2xl:leading-26 leading-30 sm:text-22 2xl:text-23 3xl:text-30 xl:leading-27 font-ww-regular 3xl:py-20 xl:py-14 lg:py-6"
                  >
                    <p v-html="testimonial.text"></p>
                  </blockquote>
                </div>
  
                <div class="col-span-12 sm:col-span-5 md:col-span-6 sm:order-2">
                  <nuxt-img
                    sizes="xs:150px sm:170px md:300px lg:477px xl:265px 2xl:300px"
                    :src="testimonial.imgSrc"
                    :alt="testimonial.altText || 'Testimonial image'"
                    class="object-cover w-full h-full"
                    width="440"
                    height="477"
                    format="webp"
                  ></nuxt-img>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
  
          <!-- Navigation buttons -->
          <div class="absolute inset-y-0 z-10 mx-0 my-auto sm:left-3 lg:left-4 left-1">
            <button
              type="button"
              aria-label="Previous"
              class="flex items-center justify-center h-full cursor-pointer swiper-button-prev-latte group focus:outline-none"
            >
              <span
                class="flex items-center justify-center w-16 h-16 bg-white rounded-full sm:w-16 sm:h-16 lg:w-24 lg:h-24"
              >
                <svg
                  class="w-8 md:w-9"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="38px"
                  height="31px"
                  viewBox="0 0 38 31"
                >
                  <path
                    fill-rule="evenodd"
                    fill="rgb(228, 132, 20)"
                    d="M0.577,17.013 L13.840,30.420 C14.611,31.199 15.861,31.200 16.631,30.422 C17.401,29.643 17.400,28.381 16.629,27.601 L6.817,17.683 L36.369,17.683 C37.270,17.683 38.001,16.944 38.001,16.033 L38.001,15.337 C38.001,14.426 37.270,13.687 36.369,13.687 L6.459,13.687 L16.638,3.398 C17.408,2.619 17.407,1.357 16.636,0.577 C15.865,-0.202 14.616,-0.203 13.846,0.575 L0.599,13.965 C0.257,14.311 0.076,14.753 0.038,15.206 C-0.088,15.839 0.091,16.522 0.577,17.013 Z"
                  />
                </svg>
                <span class="sr-only">Previous</span>
              </span>
            </button>
          </div>
  
          <div class="absolute inset-y-0 z-20 mx-0 my-auto sm:right-3 lg:right-4 right-1">
            <button
              type="button"
              aria-label="Next"
              class="flex items-center justify-center h-full cursor-pointer group focus:outline-none swiper-button-next-latte"
            >
              <span
                class="flex items-center justify-center w-16 h-16 rotate-180 bg-white rounded-full sm:w-16 sm:h-16 lg:w-24 lg:h-24"
              >
                <svg
                  class="w-8 md:w-9"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="38px"
                  height="31px"
                  viewBox="0 0 38 31"
                >
                  <path
                    fill-rule="evenodd"
                    fill="rgb(228, 132, 20)"
                    d="M0.577,17.013 L13.840,30.420 C14.611,31.199 15.861,31.200 16.631,30.422 C17.401,29.643 17.400,28.381 16.629,27.601 L6.817,17.683 L36.369,17.683 C37.270,17.683 38.001,16.944 38.001,16.033 L38.001,15.337 C38.001,14.426 37.270,13.687 36.369,13.687 L6.459,13.687 L16.638,3.398 C17.408,2.619 17.407,1.357 16.636,0.577 C15.865,-0.202 14.616,-0.203 13.846,0.575 L0.599,13.965 C0.257,14.311 0.076,14.753 0.038,15.206 C-0.088,15.839 0.091,16.522 0.577,17.013 Z"
                  />
                </svg>
                <span class="sr-only">Next</span>
              </span>
            </button>
          </div>
        </ClientOnly>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    testimonials: {
      type: Array,
      default: () => [
        {
          text: "“My morning joy has reached a new level of quality! Excellent!!!” <br><br> - Kleoniki from California",
          imgSrc: '/assets/images/person-2.png',
        },
        {
          text: "“Best coffee option yet! It is our family's favorite, both for flavor and the way it makes us feel. Energetic yet calm, no jitters.” <br><br> - Pam Z. from Florida",
          imgSrc: '/assets/images/person-1.png',
        },
        {
          text: "“Just love the taste of this coffee! The mushrooms are not overwhelming and the coffee has a superior flavor. After trying other brands, this is by far my favorite! <br><br>- Terry",
          imgSrc: '/assets/images/img-reviews-2.jpg',
        },
        {
          text: "“This coffee is smooth and delicious just like all the Lifeboost coffees. Great products from a great company. Yay! <br><br>- Holly T.",
          imgSrc: '/assets/images/hollyt-img12.jpg',
        },
        {
          text: "“I can’t say enough about this coffee. I’ve had my subscription now for over 2 years!<br><br> We love it!<br> Mahalo!! <br><br>- MaryAnn Blanchard",
          imgSrc: '/assets/images/review-img-3.jpeg',
        },
        {
          text: "“I’m in love with the smoothness and bold flavor of life boost.  Knowing it’s mold free gives me a piece of mind also! <br><br>- Teri Lewis",
          imgSrc: '/assets/images/review-img-5.jpg',
        },
        {
          text: "“I really love this flavor coffee! A+ <br><br>- Julie Vitale",
          imgSrc: '/assets/images/review-img-6.jpg',
        },
        {
          text: "“We were sceptic about trying but glad we did. Taste great very smooth no taste of Mushroom 😅 we now have it on auto ship. <br><br>- Natasha Smith",
          imgSrc: '/assets/images/review-img-7.jpeg',
        },
      ],
    },
  });
  
  defineBuilderComponent({
    friendlyName: 'Testimonials Swiper Auto Height',
    inputs: [
      {
        name: 'testimonials',
        type: 'list',
        friendlyName: 'Testimonials List',
        subFields: [
          {
            name: 'text',
            type: 'richText',
            friendlyName: 'Testimonial Text',
            defaultValue: '',
          },
          {
            name: 'imgSrc',
            type: 'file',
            friendlyName: 'Image Source',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '',
          },
          {
            name: 'altText',
            type: 'string',
            friendlyName: 'Alt Text',
            defaultValue: 'Testimonial image',
          },
        ],
        defaultValue: [
          {
            text: "“My morning joy has reached a new level of quality! Excellent!!!” <br><br> - Kleoniki from California",
            imgSrc: '/assets/images/person-2.png',
            altText: 'Testimonial image',
          },
          {
            text: "“Best coffee option yet! It is our family's favorite, both for flavor and the way it makes us feel. Energetic yet calm, no jitters.” <br><br> - Pam Z. from Florida",
            imgSrc: '/assets/images/person-1.png',
            altText: 'Testimonial image',
          },
          {
            text: "“Just love the taste of this coffee! The mushrooms are not overwhelming and the coffee has a superior flavor. After trying other brands, this is by far my favorite! <br><br>- Terry",
            imgSrc: '/assets/images/img-reviews-2.jpg',
            altText: 'Testimonial image',
          },
          {
            text: "“This coffee is smooth and delicious just like all the Lifeboost coffees. Great products from a great company. Yay! <br><br>- Holly T.",
            imgSrc: '/assets/images/hollyt-img12.jpg',
            altText: 'Testimonial image',
          },
          {
            text: "“I can’t say enough about this coffee. I’ve had my subscription now for over 2 years!<br><br> We love it!<br> Mahalo!! <br><br>- MaryAnn Blanchard",
            imgSrc: '/assets/images/review-img-3.jpeg',
            altText: 'Testimonial image',
          },
          {
            text: "“I’m in love with the smoothness and bold flavor of life boost.  Knowing it’s mold free gives me a piece of mind also! <br><br>- Teri Lewis",
            imgSrc: '/assets/images/review-img-5.jpg',
            altText: 'Testimonial image',
          },
          {
            text: "“I really love this flavor coffee! A+ <br><br>- Julie Vitale",
            imgSrc: '/assets/images/review-img-6.jpg',
            altText: 'Testimonial image',
          },
          {
            text: "“We were sceptic about trying but glad we did. Taste great very smooth no taste of Mushroom 😅 we now have it on auto ship. <br><br>- Natasha Smith",
            imgSrc: '/assets/images/review-img-7.jpeg',
            altText: 'Testimonial image',
          },
        ],
      },
    ],
  });
  </script>
  
  <style>
  .swiper-slide {
    @apply h-full;
  }
  </style>
  